/* global $ */

class SpMenu {
  constructor() {
    this.$window          = $(window);
    this.$container = $('.SpMenu');
    this.$toggle = $('.BtnToggleMenu');
    //
    this.$header = $('.Header');

    this.$closePanel = $('.SpClosePanel');
    this.isOpen = false;
    this.$toggle.on('click', () => {
      if(this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    });
    this.$closePanel.on('click', () => {
      if(this.isOpen) {
        this.close();
      }
    });

    this.prevMode = 'pc';
    this.mode = 'pc';
    // クエリを作成
    this.spMediaQuery = window.matchMedia('(max-width: 768px)')
    if(this.spMediaQuery) {
      this.mode = 'sp';
    }

    this.$window
      .on('resize', ()=>{
        this.onWindowResize();
      });
    this.onWindowResize();
  }
  open() {
    if(!this.isOpen) {
      this.isOpen = true;
      this.$header.addClass('open-spmenu');
      $('.Header__menu').css('display', 'flex');
      $('.Header__menu').attr('aria-disabled', 'false');
      setTimeout(() => {
        $('.HeaderMenuList').addClass('HeaderMenuList--open');
      }, 50);
      this.$closePanel.css('display', 'block');
      /*
      $('body').addClass('open-spmenu');
      this.$container.stop(false)
        .animate({'top': 0, 'background-color': ''}, 350, 'easeOutExpo');
        */


    }
  }
  close() {
    if(this.isOpen) {
      this.isOpen = false;
      this.$closePanel.css('display', 'none');
      this.$header.removeClass('open-spmenu');
      $('.HeaderMenuList').removeClass('HeaderMenuList--open');

      $('.Header__menu').attr('aria-disabled', 'true');
      setTimeout(() => {
        $('.Header__menu').css('display', 'none');
      }, 300);

      /*

      this.$container.stop(false)
        .animate({'top': -340}, 250, 'easeOutExpo', () => {
          $('body').removeClass('open-spmenu');
        });
        */

    }
  }
  onWindowResize() {
    if(this.spMediaQuery.matches) {
      this.mode = 'sp';
      if(this.prevMode == 'pc') {
        this.forciblyClose();
      }
      if(!this.isOpen) {
        $('.Header__menu').attr('aria-disabled', 'true');
      }
    } else {
      this.mode = 'pc';
      if(this.prevMode == 'sp') {
        $('.Header__menu').css('display', 'block');
      }
      $('.Header__menu').attr('aria-disabled', 'false');
    }

    this.prevMode = this.mode;
  }

  forciblyClose() {
    this.isOpen = false;
    this.$header.removeClass('open-spmenu');
    $('.HeaderMenuList').removeClass('HeaderMenuList--open');
    //$('.Header__menu').attr('aria-disabled', 'true');
    $('.Header__menu').css('display', 'none');
    this.$closePanel.css('display', 'none');
  }
}

export default SpMenu;
